import { render, staticRenderFns } from "./Ambassadeurs.vue?vue&type=template&id=3de54bcf"
import script from "./Ambassadeurs.vue?vue&type=script&lang=js"
export * from "./Ambassadeurs.vue?vue&type=script&lang=js"
import style0 from "./Ambassadeurs.vue?vue&type=style&index=0&id=3de54bcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports